<section class="config-container shadow mt-4">
  <h4
    class="title configurator-subtitle collapse-button"
    [ngClass]="{ active: subStep === SubStep.Colors }"
    (click)="toggleCollapse()">
    {{ 'closet-doors.finishes.decorations' | translate }}
  </h4>
  @if (subStep === SubStep.Colors) {
    <div class="collapse-block">
      <ul class="decorations">
        @for (decoration of filteredDecorations; track decoration.id) {
          <li
            class="decoration-card"
            (click)="selectDecoration(decoration)"
            [ngClass]="{
              active: isDecorationSelected(decoration.id),
              disabled: !selectedDoorId || !selectedSectionIndex || isDecorationDisabled(decoration) || decoration.isDisabled,
            }">
            <img [src]="baseImgURL + decoration.icon" />
            <p class="decoration-title">{{ decoration.nameFr }}</p>
            <p class="decoration-code">{{ decoration.code }}</p>
          </li>
        }
        @if (!decorations) {
          <ng-casto-loader></ng-casto-loader>
        }
      </ul>

      @if (decorations && selectedDecoration) {
        <ng-casto-btn
          class="blue"
          [label]="'closet-doors.finishes.apply-all' | translate"
          [disabled]="selectedDecoration.isDisabled"
          (click)="applyAll()">
        </ng-casto-btn>
      }
    </div>
  }
</section>
